import { configureStore } from '@reduxjs/toolkit';
import { signalrMiddleware } from './middlewares/signalr';
import reducers from './reducers';

const store = configureStore({
  reducer: reducers,
  middleware: [signalrMiddleware],
});

export default store;
